import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';

export interface DeleteTranscriptQuotes {
    transcriptQuoteIds: number[];
}

export const deleteTranscriptQuotes = createAction<
    ActionType,
    DeleteTranscriptQuotes
>(ActionType.COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES);

export interface DeleteTranscriptQuotesResult extends DeleteTranscriptQuotes {}

export const deleteTranscriptQuotesResult = createAction<
    ActionType,
    DeleteTranscriptQuotesResult
>(ActionType.COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES_RESULT);
